export const MercedesClipboard = (props) => (
    <svg width={props.size || 22} height={props.size || 22} viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
        <path d="M18 3H6C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3ZM7 6H13V7H7V6ZM15 13H7V12H15V13ZM17 10H7V9H17V10Z" fill="currentColor" stroke="none"/>
    </svg>
);

